import { render } from "./ForumView.vue?vue&type=template&id=53ce1297&scoped=true"
import script from "./ForumView.vue?vue&type=script&lang=js"
export * from "./ForumView.vue?vue&type=script&lang=js"

import "./ForumView.vue?vue&type=style&index=0&id=53ce1297&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53ce1297"]])

export default __exports__